export const gritterAlertPush = (type, id, props = {}) => {
  return {type, id, props};
};

export const gritterAlertDismiss = (type, id) => {
  return {type, id};
};
